import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


// API call for users-list
export const pendingSlotlist = createAsyncThunk("pendingslot/list", async(reqbody) => {

    // console.log("reqbody==>", reqbody);
    let req_body = {};
    req_body = {...reqbody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api3/event-slot-not-created", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});


export const redundantEvent = createAsyncThunk("redundantevent/list", async(reqbody) => {

    // console.log("reqbody==>", reqbody);
    let req_body = {};
    req_body = {...reqbody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api3/redundant-event-array-list", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});





const PendingSlotReducer = createSlice({
    name: 'PendingSlotReducer',
    initialState: {
        submitting: false,

        loading: false,
        submitted: false,
        resMessage: null,

        successmsg: null,
        success: false,
        failed: false,
        pendingslotdata: [],
        redundanteventdata:[]
    },

    reducers: {

        setdata(state, action) {

        }


    },
    extraReducers: {

        /// #################### USER LISting ###############################
        [pendingSlotlist.rejected]: (state, action) => {
            state.loading = false;
            state.successAction = false;

        },
        [pendingSlotlist.pending]: (state, action) => {
            // console.log("action p", action)
            // state.usersList = [];
            state.loading = true;
        },
        [pendingSlotlist.fulfilled]: (state, action) => {
            // console.log("action f storedata", action)
            if (action.payload.status === 'success') {

                state.pendingslotdata = action.payload.results.res;
                state.message = action.payload.status;
                state.loading = false;
                state.tokenRequired = false;
                state.tokenRequiredMsg = ''
            }
            // if (action.payload.status === 'error') {
            //     if (action.payload.results === "Token required" || action.payload.results === "Invalid Token") {
            //         state.tokenRequired = true;
            //         state.tokenRequiredMsg = action.payload.results;
            //     }
            // }
        },
        [redundantEvent.rejected]: (state, action) => {
            state.loading = false;
            state.successAction = false;

        },
        [redundantEvent.pending]: (state, action) => {
            // console.log("action p", action)
            // state.usersList = [];
            state.loading = true;
        },
        [redundantEvent.fulfilled]: (state, action) => {
            console.log("action f storedata", action)
            if (action.payload.status === 'success') {

                state.redundanteventdata = action.payload.results.res;
                state.message = action.payload.status;
                state.loading = false;
                state.tokenRequired = false;
                state.tokenRequiredMsg = ''
            }
            // if (action.payload.status === 'error') {
            //     if (action.payload.results === "Token required" || action.payload.results === "Invalid Token") {
            //         state.tokenRequired = true;
            //         state.tokenRequiredMsg = action.payload.results;
            //     }
            // }
        },





    }
})

export default PendingSlotReducer.reducer;
export const { setdata } = PendingSlotReducer.actions;